<app-count-box
  icon="fas fa-calendar"
  mode="view"
  [text]="text"
  [styleClass]="styleClass"
  [label]="title"
  [count]="store.count()"
  severity="secondary" />
